// extracted by mini-css-extract-plugin
module.exports = {"container":"i_B","content":"i_C","top":"i_D","center":"i_E","left":"i_F","right":"i_G"};